import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAgeGatedTerms } from '../api/adserver';
import { RootState } from './rootReducer';
import { AppThunk } from './store';

interface TermsState {
  content: string;
  isLoading: boolean;
}

let initialState = {
  content: '',
  isLoading: false,
};

export const ageGatedTermsSlice = createSlice({
  name: 'ageGatedTerms',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setContent(state, action: PayloadAction<string>) {
      state.content = action.payload;
      state.isLoading = false;
    },
  },
});

export const selectAgeGatedTerms = createSelector(
  (state: RootState) => state.ageGatedTerms,
  (ageGatedTermsSliceParam: TermsState) => {
    const { content, isLoading } = ageGatedTermsSliceParam;

    return { content, isLoading };
  },
);

const { setContent, setLoading } = ageGatedTermsSlice.actions;

export const fetchAgeGatedTerms = (): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data } = await getAgeGatedTerms();
      dispatch(setContent(data.body));
    } catch (error) {
      console.log('terms fetch error', error);
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export default ageGatedTermsSlice.reducer;
